module.exports = __webpack_public_path__ + "img/beer_id-66.6f10bc89.png";